/**
 * Dakika cinsinden süreyi okunabilir "X Saat Y Dakika" biçiminde döndürür.
 * Örn: 90 → "1 Saat 30 Dakika", 60 → "1 Saat", 125 → "2 Saat 5 Dakika",
 * 30 → "30 Dakika". (Fonksiyon adı geçmiş uyumluluk için `...Float` kaldı;
 * artık ondalık saat değil saat + dakika üretir.)
 */
export function formatDurationFloat(minutes?: number | null): string {
  if (minutes == null || !Number.isFinite(minutes) || minutes <= 0) return "-";
  const total = Math.round(minutes);
  const hours = Math.floor(total / 60);
  const mins = total % 60;
  if (hours === 0) return `${mins} Dakika`;
  if (mins === 0) return `${hours} Saat`;
  return `${hours} Saat ${mins} Dakika`;
}

/** Hours + minutes alanlarından okunabilir süre üretir (API response map için). */
export function formatDurationFromParts(
  durationHours?: number | null,
  durationMinutes?: number | null,
): string {
  const h = typeof durationHours === "number" ? durationHours : 0;
  const m = typeof durationMinutes === "number" ? durationMinutes : 0;
  return formatDurationFloat(h * 60 + m);
}
